import React from 'react';

import type { TLeasingOrderResponse } from '@/components/App/Leasing/types';
import { OfferCard } from '@/components/Shared/ui';

interface LeasingOffersErrorProps {
  leasingOffer?: TLeasingOrderResponse;
}

const LeasingOffersError: React.FC<LeasingOffersErrorProps> = ({
  leasingOffer
}) => {
  return (
    <OfferCard className="ie-leasing-item" status="error" statusText="Ошибка">
      <OfferCard.Header title={leasingOffer?.leasingCompany.name || ''} />
    </OfferCard>
  );
};

export default LeasingOffersError;
